(function() {
    /* jshint validthis: true */
    "use strict";
    
    PAGE_HASH = PAGE_HASH || window.location.hash;

    var lang = lang || document.documentElement.lang;
    
    function closePopup(e) {
        $(this).closest(".popup").fadeOut(200);
    }
    
    window.addEventListener("resize", function(e) {
        checkWindow();
        writeResolution();
        setCoreMinHeight();
    });
    
    window.addEventListener("scroll", function(e) {
        winY = window.pageYOffset;
    });

    // Pre-initiate
    DOMInit("interactive", function(e) {
        checkWindow();
        writeResolution();
        setCoreMinHeight();
    });
    
    // Initiate
    DOMInit("complete", function(e) {
        scrollToAnchor(PAGE_HASH);
        
        bindEvent(".popup-close-btn", "click", closePopup);
    });

})();